import {
  GET_ENROLLMENT_CERTIFICATE,
  GET_ENROLLMENT_CERTIFICATE_ERROR,
  GET_ENROLLMENT_CERTIFICATE_PDF,
  GET_ENROLLMENT_CERTIFICATE_PDF_ERROR,
  GET_ENROLLMENT_CERTIFICATE_PDF_SUCCESS,
  GET_ENROLLMENT_CERTIFICATE_SUCCESS,
  GET_FILE_SELLER_PDF_ERROR,
  GET_FILE_SELLER_PDF_SUCCESS,
  SCHEDULED_ENROLLMENT_CERTIFICATE
} from './EnrollmentCertificateSection.actions'

const enrollmentCertificateState = {
  certificate: {},
  sellerCertificates: {},
  error: undefined,
  loading: true,
  pdfDownload: {},
  scheduled: false
}

/**
 * The Enrollment Certificate Section reducer.
 */
const enrollmentCertificateReducer = (state = enrollmentCertificateState, { payload, type }) => {
  switch (type) {
    case GET_ENROLLMENT_CERTIFICATE: {
      return { ...state, loading: true, scheduled: false }
    }
    case GET_ENROLLMENT_CERTIFICATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        certificate: payload.certificate,
        sellerCertificates: payload.sellerCertificates ?? enrollmentCertificateState.sellerCertificates,
        scheduled: false
      }
    }
    case GET_ENROLLMENT_CERTIFICATE_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error,
        scheduled: false
      }
    }
    case SCHEDULED_ENROLLMENT_CERTIFICATE: {
      return {
        ...state,
        scheduled: true
      }
    }
    case GET_ENROLLMENT_CERTIFICATE_PDF: {
      return {
        ...state,
        pdfDownload: {
          ...state.pdfDownload,
          loading: true
        }
      }
    }
    case GET_ENROLLMENT_CERTIFICATE_PDF_SUCCESS: {
      return {
        ...state,
        pdfDownload: {
          loading: false,
          ...payload
        }
      }
    }
    case GET_ENROLLMENT_CERTIFICATE_PDF_ERROR: {
      return {
        ...state,
        pdfDownload: {
          loading: false,
          error: payload.error
        }
      }
    }
    case GET_FILE_SELLER_PDF_SUCCESS: {
      return {
        ...state,
        pdfDownload: {
          loading: false,
          ...payload
        }
      }
    }
    case GET_FILE_SELLER_PDF_ERROR: {
      return {
        ...state,
        pdfDownload: {
          loading: false,
          error: payload.error
        }
      }
    }
    default: {
      return state
    }
  }
}

export default enrollmentCertificateReducer
